import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";

const Layout = (props) => (
    <>
        <Header/>
        <Outlet/>
    </>
)

export default Layout;